import React, { useState,useEffect } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { registerEmailVerificationSSO, registerCodeVerificationSSO } from '../../../apirapper/user.ts';
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useNavigate } from "react-router-dom";

const RegisterTwo = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationStatus, setVerificationStatus] = useState(null); // null, 'success', 'error'
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [resendText, setResendText] = useState("Send Code");
  const [timer, setTimer] = useState(null);
  const [disableResend, setDisableResend] = useState(false);

  
  const route = all_routes;

  useEffect(() => {
    if (disableResend) {
      const countdown = setInterval(() => {
        setResendText(`Resend (${timer}s)`);
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);

      if (timer === 0) {
        clearInterval(countdown);
        setDisableResend(false);
        setResendText("Resend");
      }

      return () => clearInterval(countdown);
    }
  }, [disableResend, timer]);

  const handleSendCode = async () => {
    // if (!email) {
    //   alert("Please enter an email address.");
    //   return;
    // }

    setIsLoading(true);
    setDisableResend(true); // Disable the button
    setTimer(30); // Reset timer

    try {
      await registerEmailVerificationSSO(email);
      setIsLoading(false);
      setResendText("Resend (30s)"); // Change button text
    } catch (error) {
      setIsLoading(false);
      setDisableResend(false); // Enable the button on error
      const errors = {};
      errors.email = error.response.data.message;
      setResendText("Resend");
      if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
      }
      setErrors({});
    }
  };

  const handleVerificationCodeChange = async (e) => {
    const code = e.target.value;
    setVerificationCode(code);
   
    if (code.length === 6) {
      try {
        const response = await registerCodeVerificationSSO(code);
        if (response.toString() === '200') {
          setVerificationStatus('success');
        } else {
          setVerificationStatus('error');
        }
      } catch (error) {
        setVerificationStatus('error');
        console.error("Error verifying code:", error);
      }
    } else {
      setVerificationStatus(null); // Reset if the code length is not 6
    }
  };

  const validateForm = () => {
    const errors = {};
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+}{"':;?/>.<,]).{8,}$/; // At least 8 characters, one uppercase, one lowercase, one number, one special character


    if (!email) {
      errors.email = "Email is required";
    } else if (!emailPattern.test(email)) {
      errors.email = "Invalid email address";
    }
    if (!firstName) {
      errors.firstName = "First name is required";
    }
    if (!lastName) {
      errors.lastName = "Last name is required";
    }
    // if (!password) {
    //   errors.password = "Password is required";
    // }
    if (!password) {
      errors.password = "Password is required";
    } else if (!passwordPattern.test(password)) {
      errors.password = "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character";
    }
    if (!confirmPassword) {
      errors.confirmPassword = "Confirm password is required";
    } else if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }
    if (!verificationCode) {
      errors.verificationCode = "Verification code is required";
    } else if (verificationStatus !== 'success') {
      errors.verificationCode = "Please verify your email with the code sent";
    }
    if (!agreeTerms) {
      errors.agreeTerms = "You must agree to the terms and privacy policy";
    }
    return errors;
  };

  const handleSignUp = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    setErrors({}); // Clear previous errors if any

    const atIndex = email.indexOf('@');
    const randomFiveDigits = Math.floor(10000 + Math.random() * 90000);
    const usernameWithRandomNumber = email.substring(0, atIndex) + randomFiveDigits;

    const data = {
      email: email,
      username: usernameWithRandomNumber,
      firstName: firstName,
      lastName: lastName,
      password: password,
      passwordConfirm: confirmPassword,
      code: verificationCode,
      terms: "TERMS_AND_CONDITIONS",
      tenant: {}
    };
    console.log('data', data);
    navigate(route.profiledetails, { state: data });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
        <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          <div className="login-content">
            <form onSubmit={handleSignUp} style={{ width: '80%' }}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
                </Link>
                <div className="login-userheading">
                  <h3>Create an Account</h3>
                </div>
                <div className="form-login">
                  <label>Email Address</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrors(prevErrors => ({ ...prevErrors, email: false }));
                      }}
                    />
                    <ImageWithBasePath src="assets/img/icons/mail.svg" alt="img" />
                  </div>
                  {errors.email && <span className="error-message" style={{ color: 'red' }}>{errors.email}</span>}
                </div>
                <div className="form-login">
                  <label>First Name</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                        setErrors(prevErrors => ({ ...prevErrors, firstName: false }));
                      }}
                    />
                    <ImageWithBasePath src="assets/img/icons/user-icon.svg" alt="img" />
                  </div>
                  {errors.firstName && <span className="error-message" style={{ color: 'red' }}>{errors.firstName}</span>}
                </div>
                <div className="form-login">
                  <label>Last Name</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                        setErrors(prevErrors => ({ ...prevErrors, lastName: false }));
                      }}
                      
                    />
                    <ImageWithBasePath src="assets/img/icons/user-icon.svg" alt="img" />
                  </div>
                  {errors.lastName && <span className="error-message" style={{ color: 'red' }}>{errors.lastName}</span>}
                </div>
                <div className="form-login">
                  <label>Verification Code</label>
                  <div className="form-addons" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      type="text"
                      className="form-control"
                      value={verificationCode}
                      onChange={handleVerificationCodeChange}
                      style={{ paddingRight: '100px' }} // adjust padding to accommodate the link and span
                    />
                    {/* <button
                      className={`btn btn-send-code ${isLoading ? 'loading' : ''}`}
                      style={{
                        backgroundColor: 'blue',
                        color: 'white',
                        padding: '5px 10px',
                        textDecoration: 'none',
                        position: 'absolute',
                        right: verificationStatus ? '30px' : '10px', // adjust based on the span presence
                        display: verificationStatus === 'success' ? 'none' : 'inline-block'
                      }}
                      onClick={handleSendCode}
                      disabled={isLoading || !email || disableResend} // Disable button if loading or email is empty or already disabled
                    >
                      {resendText}
                    </button> */}
                    <Link
                to="#"
                className={`btn btn-send-code ${isLoading ? 'loading' : ''}`}
                style={{
     
                  color: '#237ED1',
                  padding: '5px 10px',
                  textDecoration: 'none',
                  position: 'absolute',
                  right: verificationStatus ? '30px' : '10px', // adjust based on the span presence
                  display: verificationStatus === 'success' ? 'none' : 'inline-block'
                }}
                onClick={handleSendCode}
                disabled={isLoading || !email || disableResend} // Disable button if loading or email is empty or already disabled
              >
                {resendText}
              </Link>
                    {verificationStatus === 'success' && (
                      <span style={{ color: 'green', position: 'absolute', right: '10px', backgroundColor: 'lightgreen', borderRadius: '50%', padding: '3px' }}>✔</span>
                    )}
                    {verificationStatus === 'error' && (
                      <span style={{ color: 'red', position: 'absolute', right: '10px', backgroundColor: 'pink', borderRadius: '50%', padding: '3px'}}>✘</span>
                    )}
                  </div>
                  {errors.verificationCode && <span className="error-message" style={{ color: 'red' }}>{errors.verificationCode}</span>}
                </div>    
                <div className="form-login">
                  <label>Password</label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="pass-input"
                      value={password}
                      onChange={(e) =>  {
                        setPassword(e.target.value)
                        setErrors(prevErrors => ({ ...prevErrors, password: false }));
                      }}
                    />
                    <span
                      className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  {errors.password && <span className="error-message" style={{ color: 'red' }}>{errors.password}</span>}
                </div>
                <div className="form-login">
                  <label>
                  Confirm Password</label>
                  <div className="pass-group">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="pass-input"
                      value={confirmPassword}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value)
                        setErrors(prevErrors => ({ ...prevErrors, confirmPassword: false }));
                      }}
                    />
                    <span
                      className={`fas toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                      onClick={toggleConfirmPasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  {errors.confirmPassword && <span className="error-message" style={{ color: 'red' }}>{errors.confirmPassword}</span>}
                </div>
                <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-sm-8">
                      <div className="custom-control custom-checkbox justify-content-start">
                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input
                            type="checkbox"
                            checked={agreeTerms}
                            onChange={(e) => {
                              setAgreeTerms(e.target.checked)
                              setErrors(prevErrors => ({ ...prevErrors, agreeTerms: false }));
                            }}
                          />
                          <span className="checkmarks" />I agree to the{" "}
                          <Link to="#" className="hover-a">
                            Terms &amp; Privacy
                          </Link>
                        </label>
                      </div>
                      {errors.agreeTerms && <span className="error-message" style={{ color: 'red' }}>{errors.agreeTerms}</span>}
                    </div>
                  </div>
                </div>
                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    Sign Up
                  </button>
                </div>
                <div className="signinform">
                  <h4>
                    Already have an account ?{" "}
                    <Link to={route.signin} className="hover-a">
                      Sign In Instead
                    </Link>
                  </h4>
                </div>
                <div className="form-setlogin or-text">
                  <h4>OR</h4>
                </div>
                <div className="form-sociallink">
                  <ul className="d-flex">
                    <li  style={{width:"100%"}}>
                      <Link to="#">
                        <ImageWithBasePath src="assets/img/icons/google.png" alt="Google" />
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>Copyright © 2024 WizzTech. All rights reserved</p>
                </div>
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default RegisterTwo;
